import { getCartesianCoordinateSystem } from './coordinateSystem';
export const getXAxis = (api) => {
    return getCartesianCoordinateSystem(api).getAxis('x');
};
export const getXAxisDataValue = (coordinate, api) => {
    const axis = getXAxis(api);
    return axis.coordToData(axis.toLocalCoord(coordinate));
};
export const getXAxisCoord = (value, api) => {
    const axis = getXAxis(api);
    return axis.toGlobalCoord(axis.dataToCoord(value));
};
